import { defineComponent } from 'vue'
import NoAuth from '~/layouts/NoAuth.vue'
import Auth from '~/layouts/Auth.vue'
import AuthWithoutMenu from '~/layouts/AuthWithoutMenu.vue'

export enum Layouts {
  NO_AUTH = 'NoAuth',
  AUTH = 'Auth',
  AUTH_WITHOUT_MENU = 'AuthWithoutMenu',
}

export const LayoutComponents: Record<Layouts, ReturnType<typeof defineComponent>> = {
  [Layouts.NO_AUTH]: NoAuth,
  [Layouts.AUTH]: Auth,
  [Layouts.AUTH_WITHOUT_MENU]: AuthWithoutMenu,
}
